import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import RegistrationForm from './components/RegistrationForm';
import PrivacyPolicyModal from './components/PrivacyPolicyModal';
import SuccessConfirmation from './components/SuccessConfirmation';
import Icon from '../../components/AppIcon';

const ParticipantRegistration = () => {
  const navigate = useNavigate();
  const [registrationStep, setRegistrationStep] = useState('form');
  const [participantData, setParticipantData] = useState(null);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [activeBanner, setActiveBanner] = useState(0);
  const [bannerFading, setBannerFading] = useState(false);

  const banners = [
    {
      src: "/assets/images/WhatsApp_Image_2026-04-11_at_9.39.58_PM-1775962292337.jpeg",
      alt: "Productos Xaikus: Frutacid, Alergodex, Nogestal-1, Miolaxin, Togevit, Sindolan, Gytrogen, Ainax, HistaGrip, Noxadine, Toprax, Goixe, Otosedán, Veriux Jet"
    },
    {
      src: "/assets/images/WhatsApp_Image_2026-04-11_at_9.39.59_PM_1_-1775962449437.jpeg",
      alt: "Productos Xaikus: Mitradex, Deproxone, Togevit, Nogestal-1, Alutrin, Alergodex, Frutacid, Flatum, Sartax A, Fenacox, HistaGrip, Toprax, Gytrogen, Ompex, Veriux Jet, Xase"
    },
    {
      src: "/assets/images/WhatsApp_Image_2026-04-11_at_9.39.59_PM-1775962562735.jpeg",
      alt: "Productos Xaikus: Flatum, Nogestal-1, Deproxone, Fluvirin 3, Bioplexin, Sartax A, Mucoasmat, Dolo-Bioplexin, Goixe D, Alusor Max, Dexa-Bioplexin, Toprax, Miolaxin, Fenacox, Veriux Jet, Gytrogen"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setBannerFading(true);
      setTimeout(() => {
        setActiveBanner(prev => (prev + 1) % banners?.length);
        setBannerFading(false);
      }, 600);
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  const handleFormSubmit = (formData) => {
    const registrationData = {
      ...formData,
      registrationDate: new Date()?.toISOString(),
      participantId: `XAIKUS-${Date.now()}`
    };
    setParticipantData(registrationData);
    setRegistrationStep('success');
  };

  const handleSkipRegistration = () => {
    navigate('/roulette-game-screen');
  };

  const handleContinueToGame = () => {
    navigate('/roulette-game-screen');
  };

  return (
    <>
      <Helmet>
        <title>Registro de Participante | XAIKUS Digital Roulette</title>
        <meta
          name="description"
          content="Regístrate para participar en la ruleta digital XAIKUS y acceder a premios exclusivos en nuestros eventos médicos"
        />
      </Helmet>
      <div
        className="min-h-screen relative overflow-hidden"
        style={{ background: 'linear-gradient(135deg, #0f766e 0%, #0d9488 40%, #134e4a 100%)' }}
      >
        {/* Background overlay */}
        <div className="absolute inset-0 bg-black/20" />

        {/* Confetti Background */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(30)]?.map((_, i) => (
            <div
              key={i}
              className="absolute animate-confetti"
              style={{
                left: `${Math.random() * 100}%`,
                top: `-${Math.random() * 20}%`,
                width: `${Math.random() * 8 + 4}px`,
                height: `${Math.random() * 8 + 4}px`,
                backgroundColor: ['#EF4444', '#F59E0B', '#10B981', '#3B82F6', '#8B5CF6', '#EC4899']?.[Math.floor(Math.random() * 6)],
                opacity: Math.random() * 0.5 + 0.2,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${Math.random() * 3 + 4}s`,
                transform: `rotate(${Math.random() * 360}deg)`
              }}
            />
          ))}
        </div>

        {/* XAIKUS Header Ribbon */}
        <div className="w-full relative z-10" style={{ padding: 'clamp(8px, 1.5vw, 24px) clamp(12px, 2vw, 32px)' }}>
          <div className="max-w-7xl mx-auto flex items-center justify-between">
            <div className="flex items-center" style={{ gap: 'clamp(12px, 2vw, 32px)' }}>
              <div className="flex-shrink-0" style={{ width: 'clamp(70px, 10vw, 160px)', height: 'clamp(70px, 10vw, 160px)' }}>
                <img
                  src="/assets/images/Logo-Xaikus-RGB-Uso-Digital-1024x628-1775963646080.png"
                  alt="Logo Xaikus"
                  className="w-full h-full object-contain"
                  style={{ filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.5))', mixBlendMode: 'lighten' }}
                />
              </div>
              <h1
                className="font-black italic tracking-wide leading-tight"
                style={{
                  background: 'linear-gradient(90deg, #2dd4bf 0%, #ffffff 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  fontSize: 'clamp(14px, 2.8vw, 52px)',
                  maxWidth: 'clamp(200px, 45vw, 700px)'
                }}
              >
                ¡Vive la emoción del mundial y gana con nuestras marcas!
              </h1>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <main
          className="relative z-10 mx-auto"
          style={{
            maxWidth: 'clamp(320px, 90vw, 1100px)',
            padding: '0 clamp(12px, 3vw, 48px)',
            paddingBottom: 'clamp(80px, 12vw, 160px)'
          }}
        >
          {registrationStep === 'form' && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'clamp(16px, 3vw, 48px)' }}>
              {/* Registration Title */}
              <div className="text-center" style={{ display: 'flex', flexDirection: 'column', gap: 'clamp(8px, 1.5vw, 20px)' }}>
                <h2
                  className="font-bold text-white drop-shadow"
                  style={{ fontSize: 'clamp(20px, 3.5vw, 60px)' }}
                >
                  Registro de Participante
                </h2>
                <p
                  className="text-teal-100 mx-auto"
                  style={{ fontSize: 'clamp(12px, 1.6vw, 28px)', maxWidth: 'clamp(280px, 60vw, 800px)' }}
                >
                  Completa tu registro para participar en la ruleta digital XAIKUS y acceder a premios exclusivos
                </p>
                <div className="flex flex-wrap items-center justify-center" style={{ gap: 'clamp(12px, 2.5vw, 40px)', paddingTop: 'clamp(4px, 0.8vw, 12px)' }}>
                  {[
                    { icon: 'Shield', label: 'Datos protegidos' },
                    { icon: 'Zap', label: 'Registro rápido' },
                    { icon: 'Gift', label: 'Premios exclusivos' }
                  ]?.map(({ icon, label }) => (
                    <div key={label} className="flex items-center" style={{ gap: 'clamp(6px, 1vw, 14px)' }}>
                      <div
                        className="bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0"
                        style={{ width: 'clamp(28px, 4vw, 56px)', height: 'clamp(28px, 4vw, 56px)' }}
                      >
                        <Icon name={icon} size={Math.max(14, Math.round(window.innerWidth * 0.02))} color="#ffffff" />
                      </div>
                      <span
                        className="text-white font-medium"
                        style={{ fontSize: 'clamp(11px, 1.4vw, 24px)' }}
                      >
                        {label}
                      </span>
                    </div>
                  ))}
                </div>
                <button
                  onClick={() => setShowPrivacyModal(true)}
                  className="inline-flex items-center justify-center text-teal-200 hover:text-white transition-colors rounded-lg mx-auto touch-manipulation"
                  style={{
                    gap: 'clamp(6px, 1vw, 12px)',
                    fontSize: 'clamp(11px, 1.4vw, 22px)',
                    padding: 'clamp(8px, 1.2vw, 18px) clamp(12px, 2vw, 28px)',
                    minHeight: 'clamp(36px, 5vw, 64px)'
                  }}
                >
                  <Icon name="FileText" size={Math.max(14, Math.round(window.innerWidth * 0.018))} />
                  <span className="underline">Ver política de protección de datos</span>
                </button>
              </div>

              {/* Registration Form Card */}
              <div
                className="bg-white/10 backdrop-blur-sm rounded-xl shadow-lg border border-white/20"
                style={{ padding: 'clamp(16px, 3vw, 56px)' }}
              >
                <RegistrationForm
                  onSubmit={handleFormSubmit}
                  onSkip={handleSkipRegistration}
                  allowSkip={true}
                />
              </div>

              {/* Why Register */}
              <div
                className="bg-white/10 backdrop-blur-sm rounded-lg border border-white/20"
                style={{ padding: 'clamp(12px, 2vw, 36px)' }}
              >
                <div className="flex flex-col sm:flex-row items-start sm:items-center" style={{ gap: 'clamp(12px, 2vw, 28px)' }}>
                  <div className="flex-1" style={{ display: 'flex', flexDirection: 'column', gap: 'clamp(6px, 1vw, 14px)' }}>
                    <h3
                      className="font-semibold text-white"
                      style={{ fontSize: 'clamp(14px, 1.8vw, 30px)' }}
                    >
                      ¿Por qué registrarse?
                    </h3>
                    <ul style={{ display: 'flex', flexDirection: 'column', gap: 'clamp(6px, 1vw, 14px)' }}>
                      {[
                        'Recibe notificaciones sobre premios ganados',
                        'Accede a información exclusiva sobre productos XAIKUS',
                        'Participa en futuros eventos y promociones'
                      ]?.map((item) => (
                        <li key={item} className="flex items-start" style={{ gap: 'clamp(6px, 1vw, 12px)' }}>
                          <span className="text-teal-300 mt-0.5">•</span>
                          <span
                            className="text-teal-100"
                            style={{ fontSize: 'clamp(11px, 1.4vw, 22px)' }}
                          >
                            {item}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Products Banner Carousel */}
              <div className="w-full rounded-xl overflow-hidden shadow-lg relative" style={{ minHeight: 'clamp(60px, 10vw, 160px)' }}>
                {banners?.map((banner, index) => (
                  <img
                    key={index}
                    src={banner?.src}
                    alt={banner?.alt}
                    className="w-full h-auto object-contain"
                    style={{
                      opacity: index === activeBanner ? (bannerFading ? 0 : 1) : 0,
                      position: index === activeBanner ? 'relative' : 'absolute',
                      top: 0,
                      left: 0,
                      transition: 'opacity 0.6s ease-in-out',
                      pointerEvents: index === activeBanner ? 'auto' : 'none'
                    }}
                  />
                ))}
                {/* Carousel Dots */}
                <div className="absolute bottom-2 left-0 right-0 flex justify-center z-10" style={{ gap: 'clamp(6px, 1vw, 14px)' }}>
                  {banners?.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => {
                        setBannerFading(true);
                        setTimeout(() => { setActiveBanner(index); setBannerFading(false); }, 300);
                      }}
                      className="rounded-full transition-all duration-300 border border-white/60 touch-manipulation"
                      style={{
                        width: 'clamp(8px, 1.2vw, 18px)',
                        height: 'clamp(8px, 1.2vw, 18px)',
                        backgroundColor: index === activeBanner ? '#ffffff' : 'rgba(255,255,255,0.4)'
                      }}
                      aria-label={`Banner ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}

          {registrationStep === 'success' && participantData && (
            <SuccessConfirmation
              participantData={participantData}
              onContinue={handleContinueToGame}
            />
          )}
        </main>

        {/* Promotional Banner Ribbon - Bottom */}
        <div className="fixed bottom-0 left-0 right-0 z-40 w-full">
          <img
            src="/assets/images/WhatsApp_Image_2026-04-11_at_9.21.31_PM_4_-1775961631959.jpeg"
            alt="Por la venta de nuestras marcas participantes gana stickers y la oportunidad de obtener fabulosos premios"
            className="w-full object-cover"
            style={{ maxHeight: 'clamp(50px, 8vw, 120px)', objectPosition: 'center' }}
          />
        </div>

        <PrivacyPolicyModal
          isOpen={showPrivacyModal}
          onClose={() => setShowPrivacyModal(false)}
        />
      </div>
    </>
  );
};

export default ParticipantRegistration;